import React from 'react';

const Kesehatan = () => {
  return (
    <h1>Kesehatan</h1>
  );
};

export default Kesehatan;





